// M4 data switch for tests: DRILLER_NO_M4=1 (Node only) leaves every M4 table out of the merged catalogs, so
// tests/m4data.test.js can compute an M4-free baseline in a child process and prove seeded M1-M3 games are
// byte-identical with the M4 content merged (docs/M4_SPEC.md §0). Always true in the browser.
export const M4_DATA = !(typeof process !== 'undefined' && process.env?.DRILLER_NO_M4);
export const m4List = (list) => (M4_DATA ? list : []);
export const m4Obj = (obj) => (M4_DATA ? obj : {});
